<template>
    <mdb-container v-if="info" fluid class="bg-white py-3">
        <h1 class="mb-5"> {{ info[0].caption.text_ru }}</h1>
        <VueShowdown :markdown=info[0].full_text.richtext_ru />

        <div v-if="info[0].slug === 'rukovodstvo'" class="my-5">
            <div :key="item.id" v-for="item in contacts">
                    <mdb-row>
                        <mdb-col col="4" md="2" class="mb-3">
                            <div class="w-100" ><img :src="base + item.image.url"></div>
                        </mdb-col>
                        <mdb-col col="8" md="3" class="mb-3">
                            <div>
                                <div class="h4">{{ item.title }}</div>
                                <div class="h3 font-weight-bold">{{ item.name }}</div>
                                <div class="d-flex">
                                    <div>
                                        <i class="fas fa-phone-alt text-primary mr-4"></i>
                                    </div>
                                    <div style="font-size: 17px" class="font-weight-normal">
                                        {{ item.phone }}
                                    </div>
                                </div>
                                <div class="d-flex">
                                    <div>
                                        <i class="far fa-envelope text-primary mr-4"></i>
                                    </div>
                                    <div style="font-size: 17px" class="font-weight-normal">{{ item.email }}</div>
                                </div>
                            </div>
                        </mdb-col>
                        <mdb-col col="12" md="7" class="mb-3">
                            <div class="text-justify h5">{{ item.description }}</div>
                        </mdb-col>
                    </mdb-row>
            </div>
        </div>
        <div v-if="info[0].slug === 'filial'">
            <div :key="item.id" v-for="item in offices" class="mb-5">
                    <h2 class="h5 mb-2 font-weight-bolder">{{ item.name }}</h2>
                    <div class="pb-3 border-bottom border-gray">
                        <div class="d-flex align-items-center">
                            <span class=" font-weight-bold mr-3">Адрес:</span>
                            <span class=" font-weight-normal">{{ item.address }}</span>
                        </div>
                        <div class="d-flex align-items-center">
                            <span class=" font-weight-bold mr-3">Номер:</span>
                            <span class=" font-weight-normal">{{ item.phone }}</span>
                        </div>
                    </div>
            </div>
        </div>
    </mdb-container>

</template>

<script>

    import axios from 'axios';
    import {
        mdbContainer,
        mdbRow,
        mdbCol
    } from "mdbvue";
    import store from "../../store";

    export default {
        name: "info",
        components: {
            mdbContainer,
            mdbRow,
            mdbCol
        },
        data() {
            return {
                slug: this.$route.params.slug,
                info: null,
                pageTitle: null,
                contacts: null,
                offices: null,
                certificates: null,
                base: process.env.VUE_APP_CONTENT_URL
            }
        },
        watch: {
            $route() {
                axios.get(process.env.VUE_APP_CONTENT_URL + '/static-pages?slug=' + this.$route.params.slug + '&token=' + process.env.VUE_APP_CONTENT_REST_TOKEN, {headers:{Authorization: ''}})
                    .then(response => {
                        console.log(response, "res 1")
                        this.info = response.data;
                        this.pageTitle = this.info[0].caption.text_ru;
                        store.commit('setBreadcrumbs',['О компании', this.pageTitle]);
                    });
                if(this.$route.params.slug === 'rukovodstvo') {
                    axios.get(process.env.VUE_APP_CONTENT_URL + '/contact-page' + '?token=' + process.env.VUE_APP_CONTENT_REST_TOKEN)
                        .then(response => {
                            this.contacts = response.data.contact
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
                if(this.$route.params.slug === 'filial') {
                    axios.get(process.env.VUE_APP_CONTENT_URL + '/offices' + '?_sort=sort:ASC' + '&token=' + process.env.VUE_APP_CONTENT_REST_TOKEN)
                        .then(response => {
                          this.offices = response.data
                        })
                        .catch(error => {
                          console.log(error);
                        });
                }
            }

        },
        mounted() {
            axios.get(process.env.VUE_APP_CONTENT_URL + '/static-pages?slug=' + this.$route.params.slug + '&token=' + process.env.VUE_APP_CONTENT_REST_TOKEN, {headers:{Authorization: ''}})
                .then(response => {
                    this.info = response.data;
                    this.pageTitle = this.info[0].caption.text_ru;
                    store.commit('setBreadcrumbs',['О компании', this.pageTitle]);
                });
            if(this.$route.params.slug === 'rukovodstvo') {
                axios.get(process.env.VUE_APP_CONTENT_URL + '/contact-page' + '?token=' + process.env.VUE_APP_CONTENT_REST_TOKEN)
                    .then(response => {
                      this.contacts = response.data.contact
                    })
                    .catch(error => {
                      console.log(error);
                    });
            }
            if(this.$route.params.slug === 'filial') {
                axios.get(process.env.VUE_APP_CONTENT_URL + '/offices' + '?_sort=sort:ASC' + '&token=' + process.env.VUE_APP_CONTENT_REST_TOKEN)
                    .then(response => {
                      this.offices = response.data
                    })
                    .catch(error => {
                      console.log(error);
                    });
            }
        },
    }
</script>

<style scoped>

</style>